<template>
    <div class="root">
		<rdMeetingHearder active='home'/>
        <div class="container">
            <loading v-if='loading'/>
            <div v-else>
                <div class="banner">
                    <div class="banner-left">
                        <div class="carousel">
                            <Carousel v-model="value1" loop autoplay :autoplay-speed='8000' dots='none' arrow="never">
                                <CarouselItem v-for='item in modulars'>
                                    <div class="carousel-item">
                                        <img class="img" :src="item.AttUrl">
                                    </div>
                                </CarouselItem>
                            </Carousel>
                            <div class="indicator">
                                <div class="dots">
                                    <div class="dot" @mouseenter='value1 = i - 1' :class='{active: i - 1 == value1}' v-for='i in modulars.length'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <div class="ititle">{{info.Name}}</div>
                        <div class="icontent">
                            <span v-html="description"></span>
                            <span class="more" @click="infoShow = true">更多</span>
                        </div>
                        <div class="iaddress">
                            <span style="font-weight: bold;">地址：</span>
                            <span>{{info.Remark}}</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="ctitle">即刻预约<br>开启多特瑞精油科学之旅</div>
                    <div class="ccontent">
                        <div class="item">
                            <img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png" @click="oepnDoubt">
                            <span>预约时间：</span>
                            <DatePicker type="date" v-model='date' placeholder="预约日期" :clearable="false" :options="options" style="padding-right: 10px;" v-if="datetime.length" @on-change="changetime"></DatePicker>
                            <!-- <Tooltip :content="remark" placement="top-end" :always="true" v-if="remark"></Tooltip> -->
                            <span v-if="datetime.length">{{datetime[0].BeginTime}} - {{datetime[0].EndTime}}</span>
                            <span style="padding: 0;" v-if="!datetime.length">无可预约日期</span>
                        </div>
                        <div class="item flex" v-if="remark">
                            <span style="user-select: none;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <div style="color: #B9B9B9;">{{ remark }}</div>
                        </div>
                        <div class="item flex" v-if="rooms.length">
                            <span>{{ rooms[0].Remark }}</span>
                            <div>
                                <div v-for="(item,index) in rooms" class="checkbox">
                                    <Poptip trigger="hover" word-wrap width="200" placement="right" title="" :content="item.Description" v-if="item.Description">
                                        <ccheckbox :title="item.Name" :check="room == index" @select="select(index)"></ccheckbox>
                                    </Poptip>
                                    <ccheckbox :title="item.Name" :check="room == index" @select="select(index)" v-else></ccheckbox>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <span>参观人数：</span>
                            <Input v-model='personnum' placeholder='填写 15≤人数≤25' style="display: inline-block;width: 150px;" @on-blur="checkpersonal"></Input>
                            <span class="error" style="margin-left: 5px;" v-if="error.errornum">{{error.errornum}}</span>
                        </div>
                        <div class="item flex">
                            <span>参观团长：</span>
                            <ccheckbox class="checkbox" :title="'本人'" :check="leader == 0" @select="selectt(0)"></ccheckbox>
                            <ccheckbox class="checkbox" :title="'非本人'" :check="leader == 1" @select="selectt(1)"></ccheckbox>
                        </div>
                    </div>
                </div>
                <div class="btnbox">
                    <Button type='primary' class='btn' :loading="submitloading" @click='submit' :disabled="!datetime.length">确认预约</Button>
                </div>
            </div>
        </div>
	    <Modal v-model="ruleShow" :mask-closable="false" :closable="false" :styles="{top: '200px'}">
            <div slot='header' class="mtitle">预约规则</div>
        	<div class="modal">
                <div class="mcontent">
                    <div>尊享预约对象：</div>
                    <div style="margin-bottom: 30px;"><span style="font-weight: bold;">[{{ info.RankLabel }}]</span>及以上（限企业客户）</div>
                    <div>预约规则：</div>
                    <div>1. 每月15日 上午10:00起，开放次月预约</div>
                    <div>2. 限时取消预约：预约当月28日00:00前可自主取消预约</div>
                    <div>3. 如遇取消，当月28日上午10:00将再次开放次月预约</div>
                </div>
        	</div>
            <div slot='footer' style="text-align: center;">
                <checkbox v-model="single">我已阅读，并同意以上规则</checkbox>
                <div class="next" @click="rule">下一步</div>
            </div>
	    </Modal>
	    <Modal v-model="infoShow" :footer-hide="true" :styles="{top: '200px'}">
            <div slot='header' class="mtitle">{{info.Name}}</div>
            <div class="modal">
                <div class="mcontent">
                    <span v-html="info.Description"></span>
                </div>
                <div class="maddress">
                    <span style="font-weight: bold;">地址：</span>
                    <span>{{info.Remark}}</span>
                </div>
            </div>
	    </Modal>
	    <Modal v-model="inputInfo" width="300" :mask-closable="false" :footer-hide="true" :styles="{top: '200px'}" @on-cancel="closeInput">
        	<div class="modal">
                <div class="mtitle">参观团长</div>
                <div class="input">
                    <div>姓名<span style="color: red;">*</span></div>
                    <div><Input v-model='BookUserName' :border="false"></Input></div>
                    <div class="error" v-if="error.errorname">{{error.errorname}}</div>
                </div>
                <div class="input">
                    <div>联系方式<span style="color: red;">*</span></div>
                    <div><Input v-model='BookUserMobilePhone' :border="false" @on-blur="checkmobile"></Input></div>
                    <div class="error" v-if="error.errormoblie">{{error.errormoblie}}</div>
                </div>
                <div class="input">
                    <div>会员编号<span style="color: red;">*</span></div>
                    <div><Input v-model='BookUserVipNo' :border="false" @on-blur="checkvipno"></Input></div>
                    <div class="error" v-if="error.errorvipno">{{error.errorvipno}}</div>
                </div>
                <div class="btn" @click="confirm">确认</div>
        	</div>
	    </Modal>
	    <Modal v-model="successShow" width="300" :closable="false" :mask-closable="false" :footer-hide="true" :styles="{top: '200px'}">
        	<div class="modal">
                <div class="scontent">您已成功预约多特瑞（中国）研发中心参观之行，参观前三天我们将与团长联系，沟通注意事项。届时请准时出席，凭预约码入场。</div>
                <div class="scontent" style="color: #7F7F7F;" v-if="time">时间：{{time.ForbidTime ? time.ForbidTime.substr(0,10) : ''}} {{time.BeginTime}} - {{time.EndTime}}</div>
                <div class="scontent" style="color: #7F7F7F;">人数：{{personnum}}</div>
                <div class="btn" @click="goto">确认</div>
        	</div>
	    </Modal>
    </div>
</template>
<script>
import { mapState,mapMutations,mapActions,mapGetters } from 'vuex'
import rdMeetingHearder from '@/components/header/rdMeetingHearder'
import loading from "@/components/order/loading";
import ccheckbox from "./checkbox";
import {RE_PHONE} from '@/components/common/regex';
import util from '@/config/util'
import { cvoUrl } from "@/config/env";
export default {
    data() {
        return {
            loading: false,
            ruleShow: false,
            single: false,
            value1: 0,
            info: '',
            date: '',
            remark: '',
            description: '',
            modulars: [],
            datetime: [],
            time: '',
            rooms: [],
            room: -1,
            leader: 0,
            personnum: '',
            submitloading: false,
            infoShow: false,
            inputInfo: false,
            BookUserName: '',
            BookUserMobilePhone: '',
            BookUserVipNo: '',
            error: {
                errornum: '',
                errorname: '',
                errormoblie: '',
                errorvipno: '',
            },
            successShow: false,
        }
    },
    created() {
        this.$nextTick(function() {
            this.initData()
        })
    },
    mounted() {
    },
    watch:{
    },
    components: {
        rdMeetingHearder,
        loading,
        ccheckbox,
    },
    computed: {
        ...mapState({
            userInfo: state => state.common.wechatUserInfo,
        }),
		...mapGetters(["getAccessToken"]),
        options(){
            return {
                disabledDate:(date)=>{
                    let array = [];
                    this.datetime.forEach(item=>{
                        array.push(new Date(item.ForbidTime).valueOf());
                    })
                    return !array.includes(date.valueOf());
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'checkRDPermissionsctionAction','getRDMeetingRoomsAction','getRDuserInfoAction','postRDMeetingRoomsAction',
        ]),
        async initData(){
            this.loading = true;
            // 判断白名单权限
            let res = await this.checkRDPermissionsctionAction()
            // Table1 研发中心信息，Table2 轮播图，Table3 可用日期，Table4 活动课程
            let response = await this.getRDMeetingRoomsAction();
            console.log(response);
            if(!res || !response || !response?.Table1?.length){
                this.$Modal.warning({
                    title:'提示',
                    content:'您没有申请会议室的权限',
                    onOk:()=>{
				        location = `${cvoUrl}/vo/index.html#/home?token=${this.getAccessToken}`;
                    }
                })
                return
            }
            if(response){
                this.info = response.Table1 && response.Table1[0];
                let reg1 = new RegExp('<div style="text-indent: 2em;">','g');
                let reg2 = new RegExp('</div>','g');
                this.description = this.info.Description.replace(reg1,'').replace(reg2,'<br>').substr(0,143) + '......';
                this.modulars = response.Table2;
                this.datetime = response.Table3 && response.Table3.filter(item=>(item.RoomStatus == 'FreeRoom'));
                this.date = this.datetime.length && new Date(this.datetime[0].ForbidTime);
                this.changetime();
                this.rooms = response.Table4;
                this.selectt(0);
            }
            this.ruleShow = true;
            this.loading = false;
        },
        rule(){
            if(this.single){
                this.ruleShow = false;
            }
        },
		async oepnDoubt() {
			this.$Modal.info({
				title: "提示:",
				content: '参观内容包含专人导览及精油科学课程。每月15日上午10:00起开放次月预约，约完即止。如有取消，预约会在当月28日上午10:00重新开放。',
			});
		},
        changetime(){
            this.datetime.forEach(item=>{
                if(new Date(item.ForbidTime).valueOf() == new Date(this.date).valueOf()){
                    this.remark = item.Remark;
                }
            })
        },
        select(value){
            if(value == this.room){
                this.room = -1;
            }else{
                this.room = value;
            }
        },
        selectt(value){
            this.leader = value;
            if(value == 0){
                this.BookUserVipNo = this.userInfo.value?.binding?.register?.vip_no;
                this.BookUserName = this.userInfo.value?.binding?.name;
                this.BookUserMobilePhone = this.userInfo.value?.binding?.moblie_phone;
            }else if(value == 1){
                this.BookUserVipNo = '';
                this.BookUserName = '';
                this.BookUserMobilePhone = '';
                this.inputInfo = true;
            }
        },
        checkpersonal(){
            if (!this.personnum) {
                this.error.errornum = '请填写参观人数';
                return false;
            }else if (this.personnum < 15 || this.personnum > 25) {
                this.error.errornum = '请填写15≤人数≤25';
                return false;
            }else{
                this.error.errornum = '';
                return true;
            }
        },
        checkname(){
            if (!this.BookUserName) {
                this.error.errorname = '请填写姓名';
                return false;
            }else{
                this.error.errorname = '';
                return true;
            }
        },
        checkmobile(){
            if (!this.BookUserMobilePhone) {
                this.error.errormoblie = '请填写手机号码';
                return false;
            }else if (!RE_PHONE.test(this.BookUserMobilePhone)) {
                this.error.errormoblie = '请填写正确的手机号码';
                return false;
            }else{
                this.error.errormoblie = '';
                return true;
            }
        },
        async checkvipno(){
            if (/^[0-9]{1,8}$/.test(this.BookUserVipNo)) {
                this.BookUserVipNo = `00000000${this.BookUserVipNo}`.substring(this.BookUserVipNo.length);
            }
            if (!this.BookUserVipNo) {
                this.error.errorvipno = '请填写会员编号';
                return false;
            }else{
                let res = await this.getRDuserInfoAction(this.BookUserVipNo);
                if(res){
                    this.error.errorvipno = '';
                    return true;
                }else{
                    this.error.errorvipno = '请填写正确的会员编号';
                    return false;
                }
            }
        },
        closeInput(){
            this.selectt(0);
        },
        async verifyInput(){
            let result = true;
            if(!this.checkname()) result = false;
            if(!this.checkmobile()) result = false;
            if(!await this.checkvipno()) result = false;
            return result;
        },
        async confirm(){
            if(!await this.verifyInput()){
                return;
            }else{
                this.leader = 1;
                this.inputInfo = false;
            }
        },
        async submit(){
            if(!this.checkpersonal()) return;
            this.submitloading = true;
            let Rooms = [];
            this.datetime.forEach(item=>{
                if(new Date(item.ForbidTime).valueOf() == this.date.valueOf()){
                    this.time = item;
                }
            })
            Rooms.push({
                IsRoom: 1,
                RoomId: this.info.ID,
                ProductId: 0,
                Price: this.info.Price,
                Qty: this.personnum,
                Amount: this.info.Price * this.personnum,
                Discount: 0,
                BookingDate: util.formatDate.format(Date.fromStr(this.time.ForbidTime),'yyyy-MM-dd'),
                TimeRangeId: this.time.TimeRangeId,
            });
            if(this.room != -1){
                let rooms = this.rooms[this.room];
                Rooms.push({
                    IsRoom: 0,
                    RoomId: '',
                    ProductId: rooms.ID,
                    Price: rooms.Price,
                    Qty: 1,
                    Amount: rooms.Price * 1,
                    Discount: 0,
                    BookingDate: util.formatDate.format(Date.fromStr(this.time.ForbidTime),'yyyy-MM-dd'),
                    TimeRangeId: this.time.TimeRangeId,
                });
            }
            console.log(Rooms);
            let params = {
                Rooms,
                StoreId: this.info.StoreId,
                OrderStatus: 'Pay',
                Amount: this.room != -1 ? (this.info.Price * this.personnum) + (this.rooms[this.room].Price * 1) : this.info.Price * this.personnum,
                TotalPaid: this.room != -1 ? (this.info.Price * this.personnum) + (this.rooms[this.room].Price * 1) : this.info.Price * this.personnum,
                Discount: 0,
                BookUserName: this.BookUserName,
                BookUserMobilePhone: this.BookUserMobilePhone,
                BookUserVipNo: this.BookUserVipNo,
            }
            let response = await this.postRDMeetingRoomsAction(params);
            this.submitloading = false;
            console.log(response);
            if (typeof response?.Value == 'string') {
                this.$Modal.info({
                    title:'提示',
                    content:response?.Value,
                })
            } else if(response == -1) {
                this.$Modal.error({
                    title:'错误',
                    content:'提交异常，请稍后重试',
                })
            } else {
                this.successShow = true;
            }
        },
        goto(){
            this.successShow = false;
            this.$router.push('/rdmeeting/personal');
        },
    },
}
</script>
<style lang="scss" scoped>
.root {
	display:block;
    background-color: #eee;
}
.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0.85rem 0 20px;
    background-color: #eee;
    flex:1;
}
.banner {
    width: 100%;
    border-radius: 20px;
    background-color: white;
    display:flex;
    align-items: center;
    overflow: hidden;
    .banner-left {
        flex: 5;
        .carousel {
            width: 800px;
            max-height: 360px;
            position: relative;
            .carousel-item {
                .img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .indicator {
                position: absolute;
                width: 100%;
                bottom: 1vw;
                display: flex;
                justify-content: center;
                .dots {
                    display: flex;
                    background-color: #B4BBBF;
                    border-radius: 40px;
                    .dot {
                        cursor: pointer;
                        width: 0.1rem;
                        height: 0.1rem;
                        margin: 0.05rem;
                        border: 1px solid white;
                        border-radius: 50%;
                    }
                    .active {
                        background-color: white;
                    }
                }
            }
        }
    }
    .info {
        flex: 3;
        margin: 0 40px;
        .ititle{
            font-size: 25px;
            font-weight: bold;
        }
        .icontent{
            margin: 40px 0;
            .more{
                color: #00a2e8;
                cursor: pointer;
            }
        }
        .iaddress{}
    }
}
.content{
    width: 100%;
    margin: 20px 0;
    padding: 10px 0;
    border-radius: 20px;
    background-color: white;
    .ctitle{
        width: 100%;
        padding: 10px 0;
        font-size: 25px;
        text-align: center;
        border-bottom: 1px dashed #E0E0E0;
    }
    .ccontent{
        width: 35%;
        margin: 20px 0 20px 36%;
        white-space: nowrap;
        .item{
            margin: 10px 0;
            position: relative;
            span{
                padding: 0 5px;
            }
        }
        .tip-doubt {
			width: 15px;
            margin: 0;
            position: absolute;
            top: -10px;
            left: 60px;
            cursor: pointer;
        }
        .flex{
            display: flex;
            align-items: center;
        }
        .checkbox{
            margin: 10px 20px 10px 0;
        }
    }
}
.btnbox{
    margin: 10px 0;
    text-align: center;
    .btn{
        width: 20%;
        height: 45px;
        margin: 0 auto;
        padding: 10px 0;
        border-radius: 20px;
        cursor: pointer;
    }
}
.mtitle{
    font-size: 20px;
    text-align: center;
}
.next{
    width: 100%;
    margin: 10px 0;
    padding: 5px 0;
    color: white;
    background: #BD8BCA;
    cursor: pointer;
}
.modal{
    .mcontent{
        margin: 0 10px;
    }
    .scontent{
        margin: 10px;
    }
    .maddress{
        margin: 10px;
    }
    .input{
        width: 90%;
        margin: 15px 0;
    }
    .btn{
        width: 100px;
        margin: 0 auto;
        padding: 5px 0;
        color: white;
        background: #BD8BCA;
        border-radius: 20px;
        text-align: center;
        cursor: pointer;
    }
}
.error{
    font-size: 12px;
    color: red;
}
</style>
<style lang="scss">
.modal{
    .ivu-input{
        border: none !important;
        border-bottom: 1px dashed #BD8BCA !important;
    }
}
</style>